import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { SettingsContentPanel } from 'app/components/common/SettingsContentPanel';
import { Button, Checkbox } from 'antd';

export const DEFAULT_HOTSPOT_SETTINGS: HotspotSettings = {
    activeOnly: true,
    monitoredPeriodOnly: false,
};

export interface HotspotSettings {
    activeOnly: boolean;
    monitoredPeriodOnly: boolean;
}

export class HotspotSettingsTitle extends PureComponent {
    render() {
        return (
            <Flex direction="vertical">
                <div style={{ fontWeight: 'bold' }}>HOTSPOT SETTINGS</div>
            </Flex>
        );
    }
}

export class HotspotSettingsContent extends SettingsContentPanel<HotspotSettings> {
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '20em', padding: '1em' }}>
                <Flex className="label">
                    <Checkbox
                        checked={this.state.activeOnly}
                        onChange={value => this.setState({ activeOnly: value.target.checked })}>
                        Active hotspots only
                    </Checkbox>
                </Flex>
                <Flex className="label">
                    <Checkbox
                        checked={this.state.monitoredPeriodOnly}
                        onChange={value => this.setState({ monitoredPeriodOnly: value.target.checked })}>
                        Monitored period only
                    </Checkbox>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}
